import React from 'react';

/**
 * Consistency Brand Symbol
 * Single uppercase "C" with thick rounded stroke, open on right
 * Gradient: medium blue (upper-left) → cyan (mid) → fresh green (lower-right)
 */
export default function ConsistencySymbol({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id="consistencyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#3A7BFF" />
          <stop offset="50%" stopColor="#39E6C8" />
          <stop offset="100%" stopColor="#29E07F" />
        </linearGradient>
      </defs>
      <path
        d="M 75 20 C 85 25, 90 35, 90 50 C 90 65, 85 75, 75 80 M 75 80 C 50 90, 25 85, 15 65 C 5 45, 10 25, 30 15 C 40 10, 55 10, 65 15"
        stroke="url(#consistencyGradient)"
        strokeWidth="12"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
